import React, { Component, Fragment } from 'react';
import { Link, withRouter } from 'react-router-dom';
import { mesAutobind, instance } from '@posco/posco-shared';
import { Input, Button, SpinnerViewer } from '@posco/posco-ui-react';

import Footer from "./Footer";
import PortalRepository from "../api/PortalRepository";

import '@posco/posco-ui-react/dist/lib/mes-desktop.css';

@withRouter
@mesAutobind
class SignUp extends Component {

  @instance(PortalRepository.instance)
  static instance;

  handleSubmit = (e) => {
    e.preventDefault();
    const userInfo = {
      id: document.getElementById('id').value,
      name: document.getElementById('name').value,
      password: document.getElementById('password').value,
      empno: document.getElementById('empno').value,
    }
    try {
      return PortalRepository.instance.onCreateEmp(userInfo)
        .then(result => {
          if (result.status === 200) {
            window.location.href = '/o10t01-front/login';
          }
        });
    } catch (err) {
      console.log(err.message);
    }
  };

  componentDidMount() {
  }

  render() {
    const cssStyle = { width: '180px', height: '30px', lineHeight: '30px', marginTop: '20px',
      fontSize: '15px', /*color: '#00bc81',*/color: '#fff', textDecoration: 'none',
    };

    return (
      <Fragment>
        <div className="login-wrap">
          <div className="login-area">
            <div className="login-cont">
              <div className="login-box">
                <form onSubmit={this.handleSubmit}>
                  <Input
                    id="id"
                    placeholder="아이디"
                    icon={{ name: 'user circle' }}
                    iconPosition="left"
                    autoFocus
                  />
                  <Input
                    id="name"
                    placeholder="이름"
                    icon={{ name: 'user circle' }}
                    iconPosition="left"
                  />
                  <Input
                    id="password"
                    placeholder="비밀번호"
                    icon={{ name: 'lock' }}
                    iconPosition="left"
                    type="password"
                  />
                  <Input
                    id="empno"
                    placeholder="직번"
                    icon={{ name: 'user circle' }}
                    iconPosition="left"
                  />
                  <Button
                    type="submit"
                    variant="contained"
                    className="btn-login"
                  >
                    회원가입
                  </Button>
                  <div>
                    <Link to="/login">계정이 있으면 로그인화면으로</Link>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
        <SpinnerViewer />
        <Footer />
      </Fragment>
    );
  }
}

export default SignUp;
